module.exports = __webpack_public_path__ + "static/media/barefoot_bottomframe.5980095c.png";